
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import SubscriptionType from '@/extend/classes/SubscriptionType';
import { storeSession } from '@/generated/stores';
import HubServices from "@/generated/hub/HubServices";
import ListData, { ListItem, ColumnConfig, ListConfig, ListFilter } from '@/extend/classes/ListData';
import { Alerts } from '@/framework/base/helpers/Alerts';

import { v4 as uuidv4 } from 'uuid';


@Module({ name: 'storeSubscriptionType' })

export default class storeSubscriptionType extends VuexModule {
  // States
  private reccords: SubscriptionType[] = [];
  private config : ColumnConfig[] = [];
  private idsLoading: number[] = [];
  private dataLoading = false;
  private dataLoaded = false;
  private dataRegistered = false;

  // Getters on states for asynchronous actions
  private get subscriptionTypeLoading (): boolean {
    return this.dataLoading;
  }
  private get subscriptionTypeRegistered (): boolean {
    return this.dataRegistered;
  }

  
  public get subscriptionTypeLoaded (): boolean {
    return this.dataLoaded;
  }

  public get createNewSubscriptionType() {
    return (): SubscriptionType => { 
      return this.getSubscriptionType(0, true);
    }
  }

  
  public get getSubscriptionType () {
    return (id: number, canCreate = false): SubscriptionType => {
      if (id == 0 && !canCreate) {
        Alerts.debug("Id SubscriptionType can't be 0")
        return new SubscriptionType();
      }
      const res = this.reccords.find(c => c.id == id);
      if (res != undefined) {
        return res;
      } else {
        const copy = new SubscriptionType();
        if (id == 0) {
          if (this.reccords.length == 0) {
            copy.id = -1;
          } else {
            this.reccords.sort((a, b) => (a.id - b.id));
            copy.id = Math.min(-1, this.reccords[0].id - 1);
          }          copy.canDelete = true;          copy.canUpdate = true;
          copy.createId = uuidv4();
          this.reccords.push(copy);
        } else if (id > 0) {
          copy.id = id;
          this.reccords.push(copy);
          if (storeSession.httpCx != undefined && !this.idsLoading.includes(id)) {
            this.idsLoading.push(id);
            SubscriptionType.getForStore(id).then((data: ListData) => {
              const tmpCopy = this.reccords.find(a => a.id == id);
              if (tmpCopy) {
                tmpCopy.fromSubscriptionType(data.reccords[0] as SubscriptionType);
              }
              const config = data.config as ListConfig
              if (this.config.length == 0) {
                config.columnsConfig.forEach((column) => {
                  this.config.push(column);
                })
              } else {
                config.columnsConfig.forEach((column) => {
                  if (column.choix.length == 1) {
                    const columnConfig = this.config.find(a => a.name == column.name);
                    if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
                      const columnChoix = columnConfig.choix;
                      const newChoix = column.choix[0];
                      columnChoix.push(newChoix);
                    }
                  }
                });
              }
              const index = this.idsLoading.findIndex(x => x == id);
              if (index >= 0) {
                this.idsLoading.splice(index, 1);
              }
            })
          }
        }
        return copy
      }
    }
  }


  

  public get listSubscriptionType (): SubscriptionType[] {
    return this.reccords;
  }

  public get listConfigSubscriptionType (): ColumnConfig[] {
    return this.config;
  }


  @Mutation
  private mSubscriptionTypeRegistered (): void {
    this.dataRegistered = true;
  }

  @Mutation
  public mSubscriptionTypeClearData (): void {
    this.reccords = [];
    this.idsLoading = [];
    this.dataLoading = false;
    this.dataLoaded = false;
    this.dataRegistered = false;
  }

  @Mutation
  private mSubscriptionTypeLoading (value: boolean): void {
    this.dataLoading = value;
  }

  @Mutation
  private mSubscriptionTypeLoaded (data: ListData): void {
    this.dataLoaded = true;
    this.idsLoading.splice(0, this.idsLoading.length);
    this.reccords = [];
    data.reccords.forEach((reccord) => {
      this.reccords.push(SubscriptionType.fromJson(reccord as SubscriptionType));
    })
    SubscriptionType.getDate(this.reccords);
    this.config = data.config.columnsConfig;
  }

  @Mutation
  private mSubscriptionTypeConfigUpdated (newConfig: ListConfig): void {
    newConfig.columnsConfig.forEach((column) => {
      if (column.choix.length == 1) {
        const columnConfig = this.config.find(a => a.name == column.name);
        if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
          const columnChoix = columnConfig.choix;
          const newChoix = column.choix[0];
          columnChoix.push(newChoix);
          console.log(newChoix);
        }
      }
    });
  }

  @Mutation
  public mSubscriptionTypeCreated (obj: SubscriptionType): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      let api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareSubscriptionType(obj)) {
          api.fromSubscriptionType(obj);
        }
      } else {
        api = this.reccords.find(x => x.createId == obj.createId && obj.createId != null && obj.createId != '');
        if (api) {
          if (!api.compareSubscriptionType(obj)) {
            api.fromSubscriptionType(obj);
          } else if (api.id != obj.id ) {
            api.id = obj.id;
          }
        } else {
          this.reccords.push(obj);
        }
      }
    }
  }

  @Mutation
  public mSubscriptionTypeUpdated (obj: SubscriptionType): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      const api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareSubscriptionType(obj)) {
          api.fromSubscriptionType(obj);
        }
      } else {
        this.reccords.push(obj);
      }
    }
  }

  @Mutation
  public mSubscriptionTypeDeleted (id: number): void {
    const index = this.reccords.findIndex(x => x.id == id);
    if (index >= 0) {
      this.reccords.splice(index, 1);
    }
  }

    
  @Action
  public registerSubscriptionType (filter: ListFilter | null = null): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.subscriptionTypeRegistered && storeSession.hubUsed) {
        if (HubServices.hubReady()) {
          HubServices.registerSubscriptionType(this.subscriptionTypeCreated, this.subscriptionTypeUpdated, this.subscriptionTypeDeleted);
          this.mSubscriptionTypeRegistered();
        } else {
          setTimeout(() => resolve(this.registerSubscriptionType(filter)), 1000);
        }
      }
      if (filter != null) {
        if (HubServices.hubReady() && !this.subscriptionTypeLoading && !this.subscriptionTypeLoaded) {
          this.mSubscriptionTypeLoading(true);
          return SubscriptionType.list(filter)
            .then((data: ListData) => {
              this.mSubscriptionTypeLoaded(data);
              this.mSubscriptionTypeLoading(false);
              resolve(true);
            })
        }
      } else  {
        resolve(true);
      }
  })
}


  @Action
  public listFilteredSubscriptionType (filter: ListFilter): Promise<boolean> {
    return new Promise((resolve) => {
      if (HubServices.hubReady() && !this.subscriptionTypeLoading) {
        this.mSubscriptionTypeLoading(true);
        return SubscriptionType.list(filter)
          .then((data: ListData) => {
            this.mSubscriptionTypeLoaded(data);
            this.mSubscriptionTypeLoading(false);
            resolve(true);
          })
      }
    })
  }


  
  @Action
  public createSubscriptionType (obj: SubscriptionType): Promise<SubscriptionType> {
    return new Promise((resolve, reject) => {
      return SubscriptionType.fromJson(obj).createForStoreSubscriptionType()
        .then((reccords) => {
          this.mSubscriptionTypeCreated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  public updateSubscriptionType (obj: SubscriptionType): Promise<SubscriptionType> {
    return new Promise((resolve, reject) => {
      return SubscriptionType.fromJson(obj).updateForStoreSubscriptionType()
        .then((reccords) => {
          this.mSubscriptionTypeUpdated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }
  
  @Action
  public deleteSubscriptionType (obj: SubscriptionType): Promise<boolean> {
    return new Promise((resolve, reject) => {
      return SubscriptionType.fromJson(obj).deleteForStoreSubscriptionType()
        .then(() => {
          if (!storeSession.hubUsed) {
            this.mSubscriptionTypeDeleted(obj.id);
          }
          resolve(true);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  private subscriptionTypeCreated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mSubscriptionTypeConfigUpdated(config)
    const obj = objConfig.obj as SubscriptionType;
    this.mSubscriptionTypeCreated(SubscriptionType.fromJson(obj));
  }

  @Action
  private subscriptionTypeUpdated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mSubscriptionTypeConfigUpdated(config)
    const obj = objConfig.obj as SubscriptionType;
    this.mSubscriptionTypeUpdated(SubscriptionType.fromJson(obj));
  }

  @Action
  private subscriptionTypeDeleted (objConfig: ListItem): void {
    const obj = objConfig.obj as SubscriptionType;
    this.mSubscriptionTypeDeleted(obj.id);
  }
}
